import { PureComponent } from 'react';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import ReactPhoneInput from 'react-phone-input-2';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { Button, Container, Grid, Icon } from 'semantic-ui-react';
import { isEmpty } from 'lodash';

import { SUBSCRIPTIONS } from '../../utils/constant';
import { map, find } from '../../utils/lodash';

import {
  clearSignUpCache,
  signUpCache,
  getSubscriptions,
  postSignup,
  postSignupRequest,
} from '../../store/actions';

import './auth.scss';

class SignUp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      phone: '',
      country: '61',
      isOrganisation: false,
      telError: false,
    };
  }

  componentDidMount() {
    const { userSignupData } = this.props;

    this.setState({
      phone: userSignupData ? userSignupData.phone : '',
    });
  }

  resetForm() {
    this.setState(
      {
        phone: '',
        telError: false,
      },
      () => {
        this.form && this.form.reset();
      }
    );
  }

  async handleValidSubmit(event, values) {
    try {
      const { signUpCache, setFinal, postSignupRequest } = this.props;
      const { phone, isOrganisation } = this.state;
      const telError = this.teleError();
      if (telError) {
        return;
      }
      values.phone = phone.replace(/\D/g, '');

      if (isOrganisation && !telError) {
        await postSignupRequest(values, this);
        return;
      }

      if (!telError && !isOrganisation) {
        await signUpCache(values);
        if (!isOrganisation) {
          setFinal();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  handleInvalidSubmit() {
    this.teleError();
    return;
  }

  organisation(isState) {
    this.setState({
      isOrganisation: isState ? true : false,
      telError: false,
    });
  }

  teleError() {
    const { phone, country } = this.state;
    const telError =
      phone === '+' || phone === `+${country}`
        ? true
        : isEmpty(phone)
          ? true
          : false;
    this.setState({ telError });
    return telError;
  }

  render() {
    const { isOrganisation, telError } = this.state;
    const { userSignupData, postSubOrgLoading, t } = this.props;
    return (
      <Grid.Row>
        <Container className="right-heading-container">
          <label className="headerText">{t('auth.sign_up.title')}</label>
          <br></br>
          <label className="headerDescription">
            {t('auth.sign_up.subtitle')}
          </label>
          <br></br>
          <label className="accountTypeHeader">
            {t('auth.sign_up.what_type_of_account')}
          </label>
          <div className="cardStyle">
            <div
              className={
                isOrganisation
                  ? 'card-style-custom-one'
                  : 'card-style-custom-one-clicked'
              }
              onClick={() => this.organisation(false)}
            >
              <div className="icon-style">
                <div className="icon-style-custom">
                  <Icon
                    name="user outline"
                    size="large"
                    className={'icon-color-style-one'}
                  ></Icon>
                </div>

                <div className="para-style-custom">
                  <p
                    className={isOrganisation ? 'MainText' : 'MainText-clicked'}
                  >
                    {t('account_type.individual')}
                  </p>
                  <p className={'SubText-one'}>
                    {t('auth.sign_up.to_manage_your_own_activities')}
                  </p>
                </div>
              </div>
            </div>

            <div
              className={
                isOrganisation
                  ? 'card-style-custom-two-clicked'
                  : 'card-style-custom-two'
              }
              onClick={() => this.organisation(true)}
            >
              <div className="icon-style">
                <div className="icon-style-custom">
                  <Icon
                    name="suitcase"
                    size="large"
                    className={'icon-color-style-two'}
                  ></Icon>
                </div>

                <div className="para-style-custom">
                  <p
                    className={isOrganisation ? 'MainText-clicked' : 'MainText'}
                  >
                    {t('account_type.organisation')}
                  </p>
                  <p className={'SubText-two'}>
                    {t('auth.sign_up.multiple_users_in_one_organisation')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {!isOrganisation ? (
            <AvForm
              className={'form-group-conatiner'}
              model={userSignupData ? userSignupData : null}
              ref={(c) => (this.form = c)}
              onValidSubmit={(event, values) =>
                this.handleValidSubmit(event, values)
              }
              onInvalidSubmit={() => this.handleInvalidSubmit()}
              autoComplete="none"
            >
              <div className=" nameFields">
                <div className="form-group-style-one">
                  <AvField
                    label={t('formulary.first_name')}
                    placeholder={t('formulary.placeholder.enter_first_name')}
                    className="signin-inputs"
                    name="firstName"
                    type="text"
                    errorMessage={t(
                      'formulary.validation.please_enter_valid_first_name'
                    )}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t(
                          'formulary.validation.first_name_required'
                        ),
                      },
                    }}
                  />
                </div>

                <div className="form-group-style-two">
                  <AvField
                    label={t('formulary.surname')}
                    placeholder={t('formulary.placeholder.enter_surname')}
                    className="signin-inputs"
                    name="surname"
                    errorMessage={t(
                      'formulary.validation.please_enter_valid_surname'
                    )}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t(
                          'formulary.validation.surname_required'
                        ),
                      },
                    }}
                  />
                </div>
              </div>

              <div className="form-group">
                <label for="phone">{t('formulary.phone_number')}</label>
                <ReactPhoneInput
                  inputExtraProps={{
                    name: 'phone',
                    required: true,
                  }}
                  defaultCountry={'au'}
                  value={this.state.phone}
                  onChange={(phone, country) =>
                    this.setState({
                      phone,
                      country: country.dialCode,
                    })
                  }
                  inputClass={
                    telError
                      ? 'phone-input-style-tel-error'
                      : 'phone-input-style  '
                  }
                  onBlur={() => this.teleError()}
                />
                {telError ? (
                  <label className="required-input">
                    {t('formulary.validation.phone_required')}
                  </label>
                ) : null}
              </div>

              <AvField
                label={t('common.email')}
                placeholder={t('formulary.placeholder.example_email')}
                autoComplete="new-email"
                className="signin-inputs"
                name="email"
                type="email"
                errorMessage={t(
                  'formulary.validation.please_enter_valid_email'
                )}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t('formulary.validation.please_enter_email'),
                  },
                }}
              />

              <AvField
                label={t('formulary.password')}
                autoComplete="new-password"
                placeholder={t('formulary.placeholder.7_plus_characters')}
                className="signin-inputs pass"
                name="password"
                type="password"
                minLength="7"
                validate={{
                  required: {
                    value: true,
                    errorMessage: t(
                      'formulary.validation.please_enter_password'
                    ),
                  },
                  minLength: {
                    value: 7,
                    errorMessage: t(
                      'formulary.validation.password_must_have_at_least_7_characters'
                    ),
                  },
                }}
              />

              <Button
                type="submit"
                className="btn btn-primary signin-button"
                content={
                  isOrganisation ? t('actions.sign_up') : t('actions.submit')
                }
                loading={isOrganisation ? postSubOrgLoading : null}
                disabled={isOrganisation ? postSubOrgLoading : null}
              />
              <label className={'alreadyContent'}>
                {t('auth.sign_up.already_have_an_account')}
                <Link to={'/signin'}>
                  <label className={'signin-label'}>
                    {' '}
                    {t('actions.sign_in')}
                  </label>
                </Link>
              </label>
            </AvForm>
          ) : (
            <AvForm
              className={'form-group-conatiner'}
              model={userSignupData ? userSignupData : null}
              ref={(c) => (this.form = c)}
              onValidSubmit={(event, values) =>
                this.handleValidSubmit(event, values)
              }
              onInvalidSubmit={() => this.handleInvalidSubmit()}
              autoComplete="none"
            >
              <AvField
                label={t('formulary.organisation_name')}
                placeholder={t('formulary.placeholder.enter_organisation_name')}
                className="signin-inputs"
                name="orgName"
                type="text"
                errorMessage={t(
                  'formulary.validation.please_enter_valid_organisation_name'
                )}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t(
                      'formulary.validation.organisation_name_required'
                    ),
                  },
                }}
              />
              <div className=" nameFields">
                <div className="form-group-style-one">
                  <AvField
                    label={t('formulary.first_name')}
                    placeholder={t('formulary.placeholder.enter_first_name')}
                    className="signin-inputs"
                    name="orgFirstName"
                    type="text"
                    errorMessage={t(
                      'formulary.validation.please_enter_valid_first_name'
                    )}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t(
                          'formulary.validation.first_name_required'
                        ),
                      },
                    }}
                  />
                </div>

                <div className="form-group-style-two">
                  <AvField
                    label={t('formulary.surname')}
                    placeholder={t('formulary.placeholder.enter_surname')}
                    className="signin-inputs"
                    name="orgSurname"
                    errorMessage={t(
                      'formulary.validation.please_enter_valid_surname'
                    )}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t(
                          'formulary.validation.surname_required'
                        ),
                      },
                    }}
                  />
                </div>
              </div>

              <AvField
                label={t('common.email')}
                placeholder={t('formulary.placeholder.example_email')}
                autoComplete="new-email"
                className="signin-inputs"
                name="orgEmail"
                type="email"
                errorMessage={t(
                  'formulary.validation.please_enter_valid_email'
                )}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t('formulary.validation.please_enter_email'),
                  },
                }}
              />
              <div className="form-group">
                <label for="orgPhone">{t('formulary.phone_number')}</label>
                <ReactPhoneInput
                  inputExtraProps={{
                    name: 'phone',
                    required: true,
                  }}
                  defaultCountry={'au'}
                  value={this.state.phone}
                  onChange={(phone, country) =>
                    this.setState({
                      phone,
                      country: country.dialCode,
                    })
                  }
                  inputClass={
                    telError
                      ? 'phone-input-style-tel-error'
                      : 'phone-input-style  '
                  }
                  onBlur={() => this.teleError()}
                />
                {telError ? (
                  <label className="required-input">
                    {t('formulary.validation.phone_required')}
                  </label>
                ) : null}
              </div>
              <Button
                type="submit"
                className="btn btn-primary signin-button"
                content={
                  isOrganisation ? t('actions.submit') : t('actions.sign_up')
                }
                loading={isOrganisation ? postSubOrgLoading : null}
                disabled={isOrganisation ? postSubOrgLoading : null}
              />
              <label className={'alreadyContent'}>
                {t('auth.sign_up.already_have_an_account')}
                <Link to={'/signin'}>
                  <label className={'signin-label'}>
                    {' '}
                    {t('actions.sign_in')}
                  </label>
                </Link>
              </label>
            </AvForm>
          )}
        </Container>
      </Grid.Row>
    );
  }
}

class SubscriptionDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      subscription: null,
    };
  }

  componentDidMount() {
    const { getSubscriptions } = this.props;

    getSubscriptions();
  }

  async handleValidSubmit(event, values) {
    try {
      const { userSignupData, postSignup, navigate } = this.props;

      values = {
        ...userSignupData,
        ...values,
      };

      await postSignup(values, navigate);
    } catch (error) {
      console.error(error);
    }
  }

  onChangeSubs(subscription) {
    this.setState({
      subscription,
    });
  }

  renderGroups() {
    return map(this.props.subscriptions, (item, i) => {
      const isIndividual = item.accountTypes.includes('INDIVIDUAL');
      if (!isIndividual) return null;
      return (
        <option key={i} value={item.id}>
          {item.title}
        </option>
      );
    });
  }

  render() {
    const { subscription } = this.state;
    const { t, postOrgLoading } = this.props;

    const subDetails = find(
      SUBSCRIPTIONS(this.props.t),
      (sub) => sub.id === Number(subscription)
    );

    return (
      <Grid.Row>
        <Container className="right-heading-container">
          <label className="headerText">
            {t('auth.subscription_details.subscription_details')}
          </label>
          <br></br>
          <label className="headerDescription">
            {t(
              'auth.subscription_details.select_your_subscription_plan_and_enjoy_a_14_days_free_trial'
            )}
          </label>
          <label className={'subscriptionText'}>
            {t('auth.subscription_details.subscription_plan')}
          </label>
          <AvForm
            onValidSubmit={(event, values) =>
              this.handleValidSubmit(event, values)
            }
          >
            <AvField
              type="select"
              name="subscription"
              className="sub-inputs"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'auth.subscription_details.subscription_type_required'
                  ),
                },
              }}
              onChange={(e) => this.onChangeSubs(e.target.value)}
            >
              <option value="" defaultValue disabled>
                {t('auth.subscription_details.select_subscription_type')}
              </option>
              {this.renderGroups()}
            </AvField>
            {subDetails ? (
              <div className="sub-detail-container-verification">
                <label className="plan-include-text">
                  {t('auth.subscription_details.your_plan_includes')}
                </label>

                <Grid columns={1} stackable>
                  <Grid.Row className="detail">
                    {map(subDetails.includes, (inc, i) => (
                      <div>
                        <label className={'orangeCorrectIcon'}>
                          &#10004;&nbsp;&nbsp;
                        </label>
                        <label className={'planList'}>{inc}</label>
                      </div>
                    ))}
                  </Grid.Row>
                </Grid>
              </div>
            ) : null}
            <Button
              type="submit"
              className="btn btn-primary signin-button "
              loading={postOrgLoading}
              disabled={postOrgLoading}
            >
              {t('actions.submit')}
            </Button>
          </AvForm>
        </Container>
      </Grid.Row>
    );
  }
}

SubscriptionDetails = withTranslation()(SubscriptionDetails);

class Parent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      final: false,
      load: false,
    };
  }

  componentDidMount() {
    const { clearSignUpCache } = this.props;
    this.setState({ load: true }, () => {
      clearSignUpCache();
      this.setState({ load: false });
    });
  }

  setFinal() {
    const { final } = this.state;
    this.setState({
      final: !final,
    });
  }

  render() {
    const { final, load } = this.state;
    if (load) return null;
    return (
      <div className="parent-width">
        {final ? (
          <Grid>
            {' '}
            <SubscriptionDetails {...this.props} />
          </Grid>
        ) : (
          <Grid>
            {' '}
            <SignUp {...this.props} setFinal={() => this.setFinal()} />{' '}
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSignupData: state.authentication.userSignupData,
    subscriptions: state.extra.subscriptions,
    organization: state.organization,
    postOrgLoading: state.admin.postOrgLoading,
    postSubOrgLoading: state.admin.postSubOrgLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      signUpCache,
      clearSignUpCache,
      getSubscriptions,
      postSignup,
      postSignupRequest,
    },
    dispatch
  );
};

Parent = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Parent));

export default Parent;
